<template>
    <v-dialog v-model="getModalCadastroSecaoProduto" max-width="500px" transition="dialog-transition">
        <v-card>
            <v-card-title>
                Cadastro de Departamento
            </v-card-title>
            <v-form class="px-3" ref="form">
                <v-card-text>
                    <v-layout row wrap>
                        <v-text-field dense outlined v-model="getSecaoProduto.secao" label="Departamento" class="ml-2 mr-2" :rules="rules.secao" @keyup.13="salvar"></v-text-field>	
                    </v-layout>
                </v-card-text>
                <v-card-actions>
                    <v-btn outlined color="default" @click="setModalCadastroSecaoProduto(false)">Voltar</v-btn>
                    <v-btn outlined color="error" @click="setModalExcluirSecaoProduto(true)" v-if="getSecaoProduto.id">Excluir</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn outlined color="success" @click="salvar">Salvar</v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>
</template>
<script>
    import {mapActions, mapGetters} from 'vuex'
    export default {
        data(){
            return {
                rules: {
                    secao: [
                        v => !!v || 'Campo obrigatório.'
                    ]
                }
            }
        },
        computed: {
            ...mapGetters([
            'getModalCadastroSecaoProduto',
            'getSecaoProduto'
            ])
        },
        methods: {
            ...mapActions([
            'salvarSecaoProduto',
            'atualizarSecaoProduto',
            'excluirSecaoProduto',
            'setModalCadastroSecaoProduto',
            'setModalExcluirSecaoProduto',
            ]),
            salvar(){
                if(this.$refs.form.validate()){ 
                    if(this.getSecaoProduto.id){
                        this.atualizarSecaoProduto(this.getSecaoProduto)
                    }else{
                        this.salvarSecaoProduto(this.getSecaoProduto)
                    }
                }
            }
        },
    }
</script>